import React from 'react'
import sliceItems from "./sliceItems"
import Styles from "./harvestRanking.module.css"
import anime from "animejs"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { Loader } from 'semantic-ui-react'


class HarvestRanking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            appName: '',
            EmployeeList: [],
            currentPage: 2,
            rowsPerPage: 8,
            fruit:'',
            slicedList: [], //Activities.slice(0, 3),
            sendNextPage: () => {
                this.props.nextPageProp('ActivitiesScreen');
            },
        }
    }
    componentDidMount() {
        console.log('harvest')
        this.setUpComponent()
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    setUpComponent = async () => {
        await this.getData()
    }
    getData = async () => {
        try {
            const snapShot = await firebase.firestore().collection('Produccion').get()
            const appName = (await firebase.firestore().collection('Info').doc('info').get()).data().nombre
            const gold = await firebase.storage().ref().child(`images/site-pics/gold.png`).getDownloadURL()
            const silver = await firebase.storage().ref().child(`images/site-pics/silver.png`).getDownloadURL()
            const bronze = await firebase.storage().ref().child(`images/site-pics/bronze.png`).getDownloadURL()
            let EmployeeList = []
            const NameIndexMap = {}
            let fruit=''
            for (let i = 0; i < snapShot.docs.length; i++) {
                if (!snapShot.docs[i].exists) break
                const prod = snapShot.docs[i]
                fruit=prod.data().fruta
                if (NameIndexMap[prod.data().empleado]===undefined) {
                    NameIndexMap[prod.data().empleado]=EmployeeList.length
                    EmployeeList.push({
                        empleado: prod.data().empleado,
                        cajas: prod.data().fruta==='Zarzamora'? prod.data().totalCajas: prod.data().totalBotes,
                    })
                }
                else {
                    EmployeeList[NameIndexMap[prod.data().empleado]].cajas += fruit==='Zarzamora' ? prod.data().totalCajas : prod.data().totalBotes
                }
            }
            if (EmployeeList.length === 0) return this.state.sendNextPage()
            EmployeeList = EmployeeList.sort((a, b) => {
                return b.cajas - a.cajas
            })
            for (let i = 0; i < EmployeeList.length; i++) {
                EmployeeList[i].index = i + 1
            }
            this.setState({
                EmployeeList: EmployeeList,
                slicedList: EmployeeList.slice(0, this.state.rowsPerPage),
                appName: appName,
                loaded: true,
                gold,
                silver,
                bronze,
                fruit,
            })
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.EmployeeList !== this.state.EmployeeList) {
            this.setTimer(this.state.EmployeeList)
        }
    }
    setTimer = (Activities) => {
        let maxSection = Math.ceil(Activities.length / this.state.rowsPerPage);
        this.interval = setInterval(() => {
            if (this.state.currentPage <= maxSection) {
                anime({
                    targets: 'table',
                    translateX: { value: '120%', duration: 500 },
                    direction: 'reverse',
                })
                const slicedList = sliceItems(Activities, this.state.rowsPerPage, this.state.currentPage)
                const currentPage = this.state.currentPage + 1
                this.setState({
                    slicedList: slicedList,
                    currentPage: currentPage,
                })
            } else if (this.state.currentPage > maxSection) {
                return this.state.sendNextPage()
            }
        }, 10000)
    }
    render() {

        let slicedList = this.state.slicedList;
        return (
            <>
                <Loader className={Styles.loader} active={!this.state.loaded}></Loader>
                <div className={`${Styles.container}`} hidden={!this.state.loaded}>

                    <header>
                        <span className={`${Styles.title}`}>Ranking Pisca({this.state.appName})</span>
                    </header>

                    <table className={`${Styles.table}`}>
                        <tbody>
                            <tr className={`${Styles.header}`}>
                                <th></th>
                                <th>Lugar</th>
                                <th>Nombre</th>
                                <th>{this.state.fruit==='Zarzamora' ? 'Cajas' : 'Botes'}</th>
                            </tr>
                            {
                                slicedList.map((item, i) => (

                                    <tr key={i} className={`${Styles.row}`}>
                                        <td>
                                            {
                                                item.index === 1 ?
                                                    <img src={this.state.gold} alt=""></img> :
                                                    item.index === 2 ?
                                                        <img src={this.state.silver} alt=""></img> :
                                                        item.index === 3 ?
                                                            <img src={this.state.bronze} alt=""></img> :
                                                            null
                                            }
                                        </td>
                                        <td>{`${item.index}`}</td>
                                        <td>{item.empleado}</td>
                                        <td>{item.cajas}</td>
                                    </tr>

                                ))

                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
}


export default HarvestRanking;